import {CommentBox, type CommentBoxHandle, type CommentBoxProps} from '@github-ui/comment-box/CommentBox'
import type {SxProp} from '@primer/styled-react'
import type {ForwardedRef} from 'react'
import type React from 'react'
import {forwardRef} from 'react'

import {useComparisonInfo, usePullRequest, useRepository} from '@github-ui/pull-requests/pull-request-store-selectors'
import type {RepoSubject} from '@github-ui/comment-box/subject'

export type ConversationCommentBoxProps = Omit<CommentBoxProps, 'children' | 'body'> & {
  children?: React.ReactNode
  label: string
  value: string
} & SxProp

export const ConversationCommentBox = forwardRef(
  ({children, ...rest}: ConversationCommentBoxProps, ref: ForwardedRef<CommentBoxHandle>) => {
    const pullRequest = usePullRequest()
    const {baseRepository: repository} = useRepository()
    const comparisonInfo = useComparisonInfo()
    const subject: RepoSubject = {
      type: 'pull_request',
      id: {
        id: pullRequest.id,
      },
      pullRequestNumber: pullRequest.number,
      repository: {
        databaseId: repository.id,
        nwo: `${repository.ownerLogin}/${repository.name}`,
        slashCommandsEnabled: false, // TODO - follow up on this
      },
      comparison: {
        startCommitOid: comparisonInfo.selectedRange.baseOid,
        endCommitOid: comparisonInfo.selectedRange.headOid,
      },
    }

    return (
      <CommentBox
        {...rest}
        ref={ref}
        placeholder="Leave a comment"
        actions={children}
        subject={subject}
        showLabel={false}
      />
    )
  },
)

ConversationCommentBox.displayName = 'ConversationCommentBox'
